export default {
  mysql2object(date, addTime, shortYear) {
    const arDateTime = date.toString().split(' ');
    const arDate = arDateTime[0].toString().split('-');
    if (shortYear) {
      arDate[0] = arDate[0].substring(2);
    }
    const out = { y: arDate[0], m: arDate[1], d: arDate[2] };
    if (addTime) {
       out.t = arDateTime.length > 1 ? arDateTime[1] : null;
    }
    return out;
  },
  mysql2date(date, shortYear) {
    const d = this.mysql2object(date, false, shortYear);
    return `${d.d}.${d.m}.${d.y}`;
  },
  pad(val) {
    const num = Number(val);
    if (num > 9) return num;
    return `0${num}`;
  },
  format(value) {
    if (!value) return null;
    const date = new Date(value);
    const y = date.getFullYear();
    const m = this.pad(date.getMonth() + 1);
    const d = this.pad(date.getDate());
    const h = this.pad(date.getHours());
    const min = this.pad(date.getMinutes());
    return `${d}.${m}.${y} ${h}:${min}`;
  }
};
